/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProjectInputs */



/**
* | output |
* | --- |
* | "Project" |
*
* @param {ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project = /** @type {((inputs?: ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto")
	return /** @type {LocalizedString} */ ("Project")
});